import { ThemeInterface } from '@westwing/ui-kit/Theme';
import styled, { ThemeProps } from 'styled-components';
import { fromBreakpoint, TABLET } from '../../../../mediaqueries';

interface OverlayContainerProps extends ThemeProps<ThemeInterface> {
    lessPadding?: boolean;
}
export const OverlayContainer = styled.div<OverlayContainerProps>`
    align-items: flex-start;
    bottom: 0;
    display: flex;
    height: 100%;
    justify-content: center;
    position: fixed;
    transform: translateZ(0);
    width: 100vw;
    z-index: 1002;
    padding-top: ${(props: OverlayContainerProps) => (props.lessPadding ? '0' : '102px')};
    overflow: auto;

    ${fromBreakpoint[TABLET]`
        align-items: center;
        padding-top: 0;
    `}
`;
